import { render, staticRenderFns } from "./salary_list.vue?vue&type=template&id=631fd9ad"
import script from "./salary_list.vue?vue&type=script&lang=js"
export * from "./salary_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports